import { EMAIL_FORMAT_MESSAGE } from "../../../../utils/fieldMessages";

export type EventSalesBillingValues = {
  billingContactName: string;
  billingEmail: string;
  billingPhone: string;
  city: string;
  country: string;
  customerName: string;
  postalCode: string;
  province: string;
  streetAddress: string;
};

export type ValidateEventSalesBillingInput = {
  billing: EventSalesBillingValues;
  companyNameError?: string;
  requireCompanyName: boolean;
};

export const isValidEventSalesEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export const validateEventSalesBilling = ({
  billing,
  companyNameError = "Enter the company or customer name.",
  requireCompanyName,
}: ValidateEventSalesBillingInput): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (requireCompanyName && !billing.customerName.trim()) {
    errors.companyName = companyNameError;
  }
  // The billing address is optional (approved Oct 12 2026). The backend
  // issues the invoice and leaves missing address fields off it.
  if (!billing.billingContactName.trim()) {
    errors.billingContactName = "Billing Contact Name is required";
  }
  if (!billing.billingEmail.trim()) {
    errors.billingEmail = "Email is required";
  } else if (!isValidEventSalesEmail(billing.billingEmail)) {
    errors.billingEmail = EMAIL_FORMAT_MESSAGE;
  }
  if (!billing.billingPhone.trim()) {
    errors.billingPhone = "Phone is required";
  }

  return errors;
};
